import { SupportTicketMessage } from '@/api/queries/supportTicket'
import { FC, FormEvent, useEffect, useState } from 'react'
import classes from './index.module.css'

interface Props {
  feedback: SupportTicketMessage['feedback']
  onSave: (rating: 'good' | 'bad', comment: string) => Promise<void>
}

const AiAnswerFeedback: FC<Props> = ({ feedback, onSave }) => {
  const [rating, setRating] = useState<'good' | 'bad' | null>(feedback?.rating ?? null)
  const [comment, setComment] = useState(feedback?.comment ?? '')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [editing, setEditing] = useState(false)
  useEffect(() => {
    setRating(feedback?.rating ?? null)
    setComment(feedback?.comment ?? '')
  }, [feedback?.rating, feedback?.comment])

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    if (!rating || saving) return
    setSaving(true)
    setError('')
    try {
      await onSave(rating, comment.trim())
      setEditing(false)
    } catch (saveError) {
      setError((saveError as Error).message || 'Не удалось сохранить оценку. Попробуйте ещё раз.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <form className={classes.feedback} onSubmit={submit} aria-label="Оценка ответа ИИ">
      <span className={classes.feedbackLabel}>Ответ ИИ верный?</span>
      <div className={classes.feedbackButtons}>
        {(['good', 'bad'] as const).map((value) => (
          <button key={value} type="button" aria-pressed={rating === value} disabled={saving}
            onClick={() => { setRating(value); setEditing(true) }}>
            {value === 'good' ? '👍 Верный' : '👎 Неверный'}
          </button>
        ))}
      </div>
      {editing && (
        <>
          <textarea aria-label="Комментарий к оценке" placeholder="Что стоит уточнить? (необязательно)" rows={2} maxLength={2000}
            value={comment} onChange={(event) => setComment(event.target.value)} disabled={saving} />
          <button type="submit" disabled={!rating || saving}>{saving ? 'Сохраняем…' : 'Сохранить оценку'}</button>
        </>
      )}
      {!editing && feedback && <small role="status">Спасибо! Оценка сохранена.{feedback.comment && <span className={classes.feedbackComment}>{feedback.comment}</span>}</small>}
      {error && <small role="alert">{error}</small>}
    </form>
  )
}

export default AiAnswerFeedback
